import apiClient from './api';
import { Building } from 'types';

export interface OperationTimeInput {
  name: string;
  startTime: string; // "HH:MM:SS"
  endTime: string;   // "HH:MM:SS"
}

export interface BuildingCreateRequest {
  name: string;
  label: string;
  latitude: number;
  longitude: number;
  thumbnailImage: string;
  images: string[];
  operationTimes: OperationTimeInput[];
}

export const adminBuildingService = {
  /** 이미지 업로드 → URL 반환 */
  uploadImage: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<{ url: string }>(
      '/admin/buildings/images',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    return response.data.url;
  },

  /** 건물 목록 조회 */
  getBuildings: async (universityId: number): Promise<Building[]> => {
    const response = await apiClient.get<Building[]>(`/universities/${universityId}/buildings`);
    return response.data;
  },

  /** 건물 상세 조회 */
  getBuilding: async (buildingId: number): Promise<Building> => {
    const response = await apiClient.get<Building>(`/buildings/${buildingId}`);
    return response.data;
  },

  /** 시설 건물 배정 */
  assignFacilityToBuilding: async (facilityId: number, buildingId: number): Promise<void> => {
    await apiClient.patch(`/admin/facilities/${facilityId}/building`, { buildingId }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 건물 수정 */
  updateBuilding: async (buildingId: number, data: BuildingCreateRequest): Promise<void> => {
    await apiClient.put(`/admin/buildings/${buildingId}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 건물 삭제 */
  deleteBuilding: async (buildingId: number): Promise<void> => {
    await apiClient.delete(`/admin/buildings/${buildingId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 건물 생성 */
  create: async (universityId: number, data: BuildingCreateRequest): Promise<void> => {
    await apiClient.post(`/admin/universities/${universityId}/buildings`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },
};
